import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { BrandMark } from "../../components/BrandMark";

const AdminBrandingPage = () => (
  <section data-testid="admin-branding-page" className="max-w-3xl mx-auto px-6 py-12">
    <div className="bg-napoli-marble border border-napoli-gold/20 p-8 text-center">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-napoli-gold/15 text-napoli-gold mb-4">
        <Sparkles size={22} />
      </div>
      <p className="font-body font-semibold text-[10px] tracking-[0.3em] uppercase text-napoli-oxblood">
        Branding
      </p>
      <h1 className="mt-2 font-display font-bold text-[28px] sm:text-[32px] text-napoli-espresso leading-tight">
        Coming in Session 6 polish.
      </h1>
      <p className="mt-3 font-body italic text-[14px] text-napoli-espresso-soft max-w-md mx-auto">
        Your current brand uses Napoli's locked palette and typography — Cormorant Garamond, Inter, and the napoli-* color tokens.
      </p>
      <div className="mt-6 flex items-center justify-center bg-napoli-cream-warm/60 p-6 border border-napoli-gold/20">
        <BrandMark size="lg" theme="light" />
      </div>
      <Link
        to="/admin/settings"
        data-testid="branding-to-settings"
        className="mt-6 inline-flex items-center gap-1.5 font-body font-semibold text-[11px] tracking-[0.22em] uppercase text-napoli-oxblood hover:text-napoli-oxblood-dark border-b border-napoli-oxblood/60 pb-0.5"
      >
        See full preview in Settings <ArrowRight size={12} />
      </Link>
    </div>
  </section>
);

export default AdminBrandingPage;
